const EnumFormaGerarSenha = {
  InscricaoMunicipal: 1,
  LicencaPrefeitura: 2,
  LicenciamentoJuntaComercial: 3,
  NaoGerarSenhaAutorizacao: 4,
};

export default EnumFormaGerarSenha;
